/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RoleCatalog } from '../models/role-catalog';


/**
 * The MS Entra app-role catalog: what each role means, what it grants, and
 * where to assign it. Internal documentation for whoever onboards staff.
 */
@Injectable({
  providedIn: 'root',
})
export class RolesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listRoles
   */
  static readonly ListRolesPath = '/roles';

  /**
   * List the assignable MS Entra app roles.
   *
   * Returns every assignable app role with a human-readable description of
   * who should hold it and the exact permissions it grants, plus a deep
   * link to the Entra "Users and groups" blade where assignments are made.
   *
   * The payload is derived from the same role definitions the backend
   * enforces (`internal/authz`), so the published catalog cannot drift from
   * enforcement. Retired role values are deliberately absent — they are old
   * values of roles already listed here, not something to assign.
   *
   * Authentication only: the catalog is internal documentation, not
   * sensitive data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listRoles$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<RoleCatalog>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.ListRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleCatalog>;
      })
    );
  }

  /**
   * List the assignable MS Entra app roles.
   *
   * Returns every assignable app role with a human-readable description of
   * who should hold it and the exact permissions it grants, plus a deep
   * link to the Entra "Users and groups" blade where assignments are made.
   *
   * The payload is derived from the same role definitions the backend
   * enforces (`internal/authz`), so the published catalog cannot drift from
   * enforcement. Retired role values are deliberately absent — they are old
   * values of roles already listed here, not something to assign.
   *
   * Authentication only: the catalog is internal documentation, not
   * sensitive data.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listRoles(params?: {
    context?: HttpContext
  }
): Observable<RoleCatalog> {

    return this.listRoles$Response(params).pipe(
      map((r: StrictHttpResponse<RoleCatalog>) => r.body as RoleCatalog)
    );
  }

}
